import React, { useState } from "react";
import { Card, Table, Form, Dropdown, Row, Col } from "react-bootstrap";
import { FiEdit, FiTrash2 } from "react-icons/fi";
import EditTrainerModal from "../../../components/modals/hrm/training/trainers/EditTrainerModal";
import DeleteTrainerModal from "../../../components/modals/hrm/training/trainers/DeleteTrainerModal";
import TrainersHeader from "../../../components/hrm/training/TrainersHeader";

const initialData = [
  {
    id: 1,
    name: "Anthony Lewis",
    phone: "(123) 4567 890",
    email: "anthony.lewis@example.com",
    description: "Anthony is a trainer known for his expertise in leadership development.",
    status: "Active",
    img: "/assets/img/users/user-32-1.jpg",
  },
  {
    id: 2,
    name: "Brian Villalobos",
    phone: "(179) 7382 829",
    email: "brian.v@example.com",
    description: "Brian is a trainer who excels in teaching advanced technical skills.",
    status: "Active",
    img: "/assets/img/users/user-09.jpg",
  },
  {
    id: 3,
    name: "Harvey Smith",
    phone: "(184) 2719 738",
    email: "harvey.smith@example.com",
    description: "Harvey is a trainer known for his expertise in conflict resolution.",
    status: "Active",
    img: "/assets/img/users/user-01-1.jpg",
  },
  {
    id: 4,
    name: "Stephan Peralt",
    phone: "(193) 7839 748",
    email: "stephan.p@example.com",
    description: "Stephan is a trainer who enhances creative problem-solving skills.",
    status: "Active",
    img: "/assets/img/users/user-33-1.jpg",
  },
  {
    id: 5,
    name: "Doglas Martini",
    phone: "(183) 9302 890",
    email: "doglas.m@example.com",
    description: "Doglas is a trainer who enhances project management skills.",
    status: "Active",
    img: "/assets/img/users/user-34.jpg",
  },

  // NEW DATA
  {
    id: 6,
    name: "Sophia Carter",
    phone: "(201) 4567 112",
    email: "sophia.carter@example.com",
    description: "Specializes in communication and interpersonal skill development.",
    status: "Active",
    img: "/assets/img/users/user-10.jpg",
  },
  {
    id: 7,
    name: "Daniel Rodriguez",
    phone: "(145) 6678 221",
    email: "daniel.r@example.com",
    description: "Expert in software engineering and coding best practices.",
    status: "Active",
    img: "/assets/img/users/user-11.jpg",
  },
  {
    id: 8,
    name: "Emma Watson",
    phone: "(176) 9832 776",
    email: "emma.w@example.com",
    description: "Focuses on team building and organizational behavior.",
    status: "Inactive",
    img: "/assets/img/users/user-12.jpg",
  },
  {
    id: 9,
    name: "Michael Johnson",
    phone: "(189) 5543 908",
    email: "michael.j@example.com",
    description: "Trainer in business strategy and leadership coaching.",
    status: "Active",
    img: "/assets/img/users/user-13.jpg",
  },
  {
    id: 10,
    name: "Olivia Brown",
    phone: "(132) 8844 552",
    email: "olivia.b@example.com",
    description: "Expert in HR policies and employee engagement training.",
    status: "Inactive",
    img: "/assets/img/users/user-14.jpg",
  },
  {
    id: 11,
    name: "James Anderson",
    phone: "(165) 7765 332",
    email: "james.a@example.com",
    description: "Focuses on agile methodologies and scrum practices.",
    status: "Active",
    img: "/assets/img/users/user-15.jpg",
  },
  {
    id: 12,
    name: "Isabella Martinez",
    phone: "(198) 2233 665",
    email: "isabella.m@example.com",
    description: "Trainer in customer experience and service excellence.",
    status: "Active",
    img: "/assets/img/users/user-16.jpg",
  },
];

export default function TrainersPage() {
  const [data, setData] = useState(initialData);
  const [search, setSearch] = useState("");
  const [selectedTrainer, setSelectedTrainer] = useState(null);
  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);

  const filteredData = data.filter((item) =>
    item.name.toLowerCase().includes(search.toLowerCase())
  );

  const handleDelete = () => {
    setData(data.filter((d) => d.id !== selectedTrainer.id));
    setShowDelete(false);
  };

  const handleUpdate = (updated) => {
    setData(data.map((d) => (d.id === updated.id ? updated : d)));
    setShowEdit(false);
  };

  return (
<div 
style={{ padding: "15px", background: "#f8f9fa",  }} >
<TrainersHeader/>
         <Card className="border-0 shadow-sm">
      {/* HEADER */}
      <Card.Header className="bg-white d-flex justify-content-between flex-wrap">
        <h5 className="fw-semibold">Trainers List</h5>

        <Dropdown>
          <Dropdown.Toggle variant="light">
            Sort By : Last 7 Days
          </Dropdown.Toggle>
          <Dropdown.Menu align="end">
            <Dropdown.Item>Recently Added</Dropdown.Item>
            <Dropdown.Item>Ascending</Dropdown.Item>
            <Dropdown.Item>Descending</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </Card.Header>

      {/* FILTER */}
      <Card.Body>
        <Row className="mb-3">
          <Col md={6}>
            <span>Row Per Page </span>
            <Form.Select style={{ width: 80, display: "inline-block" }}>
              <option>10</option>
            </Form.Select>
            <span> Entries</span>
          </Col>

          <Col md={6} className="text-md-end mt-2 mt-md-0">
            <Form.Control
              placeholder="Search"
              style={{ maxWidth: 250, display: "inline-block" }}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </Col>
        </Row>

        {/* TABLE */}
        <div className="table-responsive">
          <Table hover>
            <thead className="table-light">
              <tr>
                <th>
                  <Form.Check />
                </th>
                <th>Name</th>
                <th>Phone</th>
                <th>Email</th>
                <th>Description</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              {filteredData.map((item) => (
                <tr key={item.id}>
                  <td>
                    <Form.Check />
                  </td>

                  <td>
                    <div className="d-flex align-items-center">
                      <img
                        src={item.img}
                        alt=""
                        style={{
                          width: 40,
                          height: 40,
                          borderRadius: "50%",
                          border: "1px solid #ddd",
                          marginRight: 10,
                        }}
                      />
                      <span className="fw-medium">{item.name}</span>
                    </div>
                  </td>

                  <td>{item.phone}</td>
                  <td>{item.email}</td>
                  <td className="text-muted">{item.description}</td>

                  <td>
                    <span className="badge bg-success d-flex align-items-center gap-1">
                      ● Active
                    </span>
                  </td>

                  <td>
                    <div className="d-flex gap-2">
                      <FiEdit
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setSelectedTrainer(item);
                          setShowEdit(true);
                        }}
                      />
                      <FiTrash2
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setSelectedTrainer(item);
                          setShowDelete(true);
                        }}
                      />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
{/* 
        <div className="d-flex justify-content-between mt-2">
          <span>Showing 1 - {filteredData.length} of {data.length}</span>
          <span className="badge bg-warning text-dark">1</span>
        </div> */}
      </Card.Body>

      {/* MODALS */}
      <EditTrainerModal
        show={showEdit}
        onHide={() => setShowEdit(false)}
        trainer={selectedTrainer}
        onSave={handleUpdate}
      />

      <DeleteTrainerModal
        show={showDelete}
        onHide={() => setShowDelete(false)}
        onDelete={handleDelete}
      />
    </Card>
</div>
  );
}